import { atom } from 'recoil';

// Atom to store the Leaflet map reference for global access
// dangerouslyAllowMutability is required because Leaflet map instances need to be mutable
export const atom_mapRef = atom<any>({
    key: 'mapRef',
    default: null,
    dangerouslyAllowMutability: true,
});

// Atom to store flyToSelectedStop callback from useMapNavigation
// Set by NewMapContainer, read by ListRender and other components that need smart fly-to
export const atom_flyToSelectedStop = atom<((stopId: string) => void) | null>({
    key: 'flyToSelectedStop',
    default: null,
    dangerouslyAllowMutability: true,
});

// Atom to store flyToFitStops callback from useMapNavigation
// Set by NewMapContainer, read on-demand by MapFilters/SavedButton for saved-bounds fly.
// Lives here (rather than duplicating the bounds math per caller) so CTA-panel + list-panel
// awareness, supercluster-aware zoom, and padding stay in one place.
import type { Stop } from '@app/shared/models/tour.type';
export const atom_flyToFitStops = atom<((stops: Stop[], options?: { padding?: number; maxZoom?: number }) => void) | null>({
    key: 'flyToFitStops',
    default: null,
    dangerouslyAllowMutability: true,
});
